import FormSelect from '../FormSelect';
import { useEffect, useRef, useState } from 'react';
import { useConnector } from '../../connectors/ConnectorContext';
import { trackFilterSelection } from '../../utils/dataLayer';

export default function MultiChoiceAsyncSelect(props) {
  const fieldId = props.fieldId;
  const filters = props.filters;
  const [fieldData, setFieldData] = useState([]);
  const prevFieldData = useRef([]);
  const connector = useConnector();

  useEffect(() => {
    const existingFilters = filters
      ? filters.find(filter => filter.field === fieldId)
      : undefined;

    if (existingFilters?.values) {
      setFieldData(
        existingFilters.values.map(filter => ({
          label: filter,
          value: filter,
        })),
      );
    } else {
      setFieldData([]);
    }
  }, [filters]);

  useEffect(() => {
    prevFieldData.current = fieldData;
  }, [fieldData]);

  const handleChange = inputValue => {
    return connector.onAutocomplete(inputValue, fieldId).then(response => {
      return response.autocompletedResults.map(item => ({
        value: item.suggestion,
        label: item.suggestion,
      }));
    });
  };

  const handleFieldData = selectedOptions => {
    selectedOptions
      .filter(option => {
        return !prevFieldData.current.some(
          prevOption => prevOption.value === option.value,
        );
      })
      .map(option => {
        trackFilterSelection(fieldId, option.value);
        return props.addFilter(fieldId, option.value, 'any');
      });

    prevFieldData.current
      .filter(
        prevOption =>
          !selectedOptions.some(option => option.value === prevOption.value),
      )
      .map(option => {
        return props.removeFilter(fieldId, option.value);
      });
  };

  const handleSelect = data => {
    setFieldData(data);
    handleFieldData(data);
  };

  const SHORT_LABEL_MAX_LENGTH = 20;

  const placeholderLabel =
    props.label.charAt(0).toLowerCase() + props.label.slice(1);

  const placeholderText =
    props.label.length <= SHORT_LABEL_MAX_LENGTH
      ? `Search ${placeholderLabel}`
      : 'Search all';
  return (
    <FormSelect
      async
      defaultOptions
      isMulti
      formHint={props.formHint}
      id={props.id}
      label={props.label}
      loadOptions={handleChange}
      noOptionsMessage={() => 'Type to search...'}
      onChange={handleSelect}
      placeholder={placeholderText}
      value={fieldData}
    />
  );
}
